import { Component, Input } from '@angular/core';
import { batchAll, CallbackResult, CallbackResultStatus, StandardColorRed } from '../../../../../../utils';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { CustomerService } from '../../../../../../services/customer/customer.service';


@Component({
  selector: 'app-bulk-add-customer-alert-modal',
  templateUrl: './bulk-add-customer-alert-modal.component.html',
  styleUrls: ['./bulk-add-customer-alert-modal.component.css']
})
export class BulkAddCustomerAlertModalComponent {
  @Input() customerIds: number[];
  @Input() savedCallback: (result: CallbackResult) => undefined;

  public alertText = '';
  public expiryDate = '';
  public colorHex = StandardColorRed.colorHex;
  public preventsCheckIn = false;
  public hasAlertIcon = false;

  public errorMessage = '';
  public serverError: number = null;

  public loadingSave = false;
  public errors: any = {};
  public numberSaved = 0;

  constructor(
    public activeModal: NgbActiveModal,
    public customerService: CustomerService
  ) {}

  public handleSave() {
    this.errorMessage = '';
    this.loadingSave = true;

    this.numberSaved = 0;
    let successfulCount = 0;


    const customerIdHandler = (customerId: number): Promise<void> => {
      // Stop early if an error message or server error is produced.
      if ((this.errorMessage !== '') || (this.serverError !== null)) {
        return Promise.resolve();
      }

      return this.customerService
        .addCustomerAlert(
          customerId,
          {
            id: null,
            url: '',
            alert_text: this.alertText,
            is_removed: false,
            expiry_date: this.expiryDate,
            color_hex: this.colorHex,
            prevents_check_in: this.preventsCheckIn,
            has_alert_icon: this.hasAlertIcon,
            created_by_id: null,
            created_by_email: '',
            updated_by_id: null,
            updated_by_email: '',
            created_date: '',
            updated_date: '',
            created_at: '',
            updated_at: ''
          }
        )
        .then(createdAlert => {
          successfulCount++;
        })
        .catch(reason => {
          if (reason.status === 403) {
            this.errorMessage = 'You do not have permission to create alerts.';
          } else if (reason.status === 400) {
            this.errors = reason.error;
            this.errorMessage = 'Please correct the errors above and try again.';
          } else {
            this.serverError = reason.status;
          }
        })
        .finally(() => {
          this.numberSaved++;
        });
    }

    batchAll(
      4,
      this.customerIds,
      customerIdHandler
    )
      .then(() => {
        if (this.errorMessage !== '') { return; }

        this.savedCallback({
          text: (
            'Alert successfully created for '
            + successfulCount.toString() + ' customers.'
          ),
          status: CallbackResultStatus.success
        });
        this.activeModal.close();
      })
      .finally(() => { this.loadingSave = false; });

  }

  public getLoadingProgressPercentageStr() {
    return Math.ceil((this.numberSaved / this.customerIds.length) * 100).toString();
  }

}
